import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ee05296"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "swiper-container-popup"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_PopupModal = _resolveComponent("PopupModal")!

  return (_ctx.showModal)
    ? _withDirectives((_openBlock(), _createBlock(_component_PopupModal, {
        key: 0,
        onCloseModal: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal = false))
      }, {
        default: _withCtx(() => [
          (_ctx.multiple)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_swiper, {
                  slidesPerView: 1,
                  spaceBetween: 30,
                  pagination: true,
                  centeredSlides: true,
                  autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
                  loop: true,
                  navigation: false,
                  modules: _ctx.modules,
                  onSwiper: _ctx.onSwiper
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sliders, (slide, index) => {
                      return (_openBlock(), _createBlock(_component_swiper_slide, {
                        key: index,
                        virtualIndex: index
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            href: slide.linkUrl,
                            target: "_blank"
                          }, [
                            _createElementVNode("img", {
                              src: slide.filename,
                              class: "w-100"
                            }, null, 8, _hoisted_3)
                          ], 8, _hoisted_2)
                        ]),
                        _: 2
                      }, 1032, ["virtualIndex"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modules", "onSwiper"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("a", {
                  href: _ctx.sliders[0].linkUrl,
                  target: "_blank"
                }, [
                  _createElementVNode("img", {
                    src: _ctx.sliders[0].filename,
                    class: "img-fluid"
                  }, null, 8, _hoisted_6)
                ], 8, _hoisted_5)
              ]))
        ]),
        _: 1
      }, 512)), [
        [_vShow, _ctx.showModal]
      ])
    : _createCommentVNode("", true)
}